import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import stylesTab from "./Report.module.scss";
import FinanceTable from "./FinanceTable.tsx";
import styles from "./Quarter.module.scss";
import { Icon } from "../../assets/Icons.tsx";

interface CardDataProps {
  financialYear?: string;
  financialQuarterData?: array;
}
const Quarter: React.FC<CardDataProps> = ({
  financialYear,
  financialQuarterData,
}) => {
  const [showSingleRelease] = useState(false);
  const [activeTab, setActiveTab] = useState("Q1");
  const FinancialQ1Data = financialQuarterData?.[0]?.sub_tab_details?.contents;
  const FinancialQ2Data = financialQuarterData?.[1]?.sub_tab_details?.contents;
  const FinancialQ3Data = financialQuarterData?.[2]?.sub_tab_details?.contents;
  const FinancialQ4Data = financialQuarterData?.[3]?.sub_tab_details?.contents;

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const downloadFile = async () => {
    const url =
      "https://www.aptech-worldwide.com/downloads/TermsOfId/Letter-of-Appointment.pdf";

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch the PDF file.");
      }
      const blob = await response.blob();
      const blobURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = "Terms_of_id.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  const renderTabContent = (downloadFile) => {
    switch (activeTab) {
      case "Q1":
        return (
          <div>
            <FinanceTable
              cardData={FinancialQ1Data || []}
              SubsidiaryCompanies={false}
              financialYear={financialYear}
            />
            {/* <div className="d-flex align-items-center mt-5">
              <Icon name="pdfIcon" height="40px" width="40px" />
              <p className={`para fw-bold mb-0 ${styles.textStyle}`}>
                <a href="https://www.aptech-worldwide.com/downloads/TermsOfId/Letter-of-Appointment.pdf">
                  Terms Of ID
                </a>
              </p>

              <span
                className={styles.downloadCircleDiv}
                onClick={() => downloadFile()}
              >
                <Icon
                  name="circleDownArrow"
                  height="40px"
                  width="40px"
                  color="#036995"
                />
              </span>
            </div> */}
          </div>
        );
      case "Q2":
        return (
          <div>
            <FinanceTable
              cardData={FinancialQ2Data || []}
              SubsidiaryCompanies={false}
              financialYear={financialYear}
            />
            {/* <div className="d-flex align-items-center mt-5">
              <Icon name="pdfIcon" height="40px" width="40px" />
              <p className={`para fw-bold mb-0 ${styles.textStyle}`}>
                <a href="https://www.aptech-worldwide.com/downloads/TermsOfId/Letter-of-Appointment.pdf">
                  Terms Of ID
                </a>
              </p>
              <span
                className={styles.downloadCircleDiv}
                onClick={() => downloadFile()}
              >
                <Icon
                  name="circleDownArrow"
                  height="40px"
                  width="40px"
                  color="#036995"
                />
              </span>
            </div> */}
          </div>
        );

      case "Q3":
        return (
          <div>
            <FinanceTable
              cardData={FinancialQ3Data || []}
              SubsidiaryCompanies={false}
              financialYear={financialYear}
            />
            {/* <div className="d-flex align-items-center mt-5">
              <Icon name="pdfIcon" height="40px" width="40px" />
              <p className={`para fw-bold mb-0 ${styles.textStyle}`}>
                <a href="https://www.aptech-worldwide.com/downloads/TermsOfId/Letter-of-Appointment.pdf">
                  Terms Of ID
                </a>
              </p>
              <span
                className={styles.downloadCircleDiv}
                onClick={() => downloadFile()}
              >
                <Icon
                  name="circleDownArrow"
                  height="40px"
                  width="40px"
                  color="#036995"
                />
              </span>
            </div> */}
          </div>
        );
      case "Q4":
        return (
          <div>
            <FinanceTable
              cardData={FinancialQ4Data || []}
              SubsidiaryCompanies={false}
              financialYear={financialYear}
            />
            {/* <div className="d-flex align-items-center mt-5">
              <Icon name="pdfIcon" height="40px" width="40px" />
              <p className={`para fw-bold mb-0 ${styles.textStyle}`}>
              <a href="https://www.aptech-worldwide.com/downloads/TermsOfId/Letter-of-Appointment.pdf">

                Terms Of ID
                </a>
              </p>
                <span className={styles.downloadCircleDiv} onClick={()=> downloadFile()}>
              <Icon
                name="circleDownArrow"
                height="40px"
                width="40px"
                color="#036995"
              />
              </span>
            </div> */}
          </div>
        );
      default:
        return <div>No Content</div>;
    }
  };

  return (
    <div id="QuarterSection" className={styles.QuarterSection}>
      {!showSingleRelease && (
        <>
          <div className="row mt-1">
            <div className="col-12 d-flex flex-column justify-content-center align-items-center">
              <ul
                className={`nav nav-pills ${stylesTab.navPills} mt-2 mb-3 d-flex justify-content-center overflow-auto`}
                id="pills-tab"
                role="tablist"
                style={{ whiteSpace: "nowrap" }}
              >
                {financialQuarterData?.map((tab) => (
                  <li
                    key={tab?.sub_tab_details?.name}
                    className="nav-item flex-shrink-0"
                    role="presentation"
                  >
                    <button
                      className={`${stylesTab.navLink} ${
                        activeTab === tab?.sub_tab_details?.name
                          ? stylesTab.navLinkActive
                          : ""
                      }`}
                      onClick={() => handleTabClick(tab?.sub_tab_details?.name)}
                      type="button"
                      role="tab"
                      aria-controls={`pills-${tab?.sub_tab_details?.name.toLowerCase()}`}
                      aria-selected={activeTab === tab?.sub_tab_details?.name}
                    >
                      {tab?.sub_tab_details?.name}
                    </button>
                  </li>
                ))}
              </ul>
              <div className="tab-content w-100" id="pills-tabContent">
                {renderTabContent(downloadFile)}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Quarter;
